import { makeVar } from '@apollo/client'

/** The wallet the Deposit dialog shows. */
export const depositWalletAddressVar = makeVar<string | null>(null)

export const isWalletDepositOpenVar = makeVar(false)

/**
 * Opens the Deposit dialog for `address`. Users fund their wallets
 * themselves: SOL for the network fees, USDT to play.
 */
export const openWalletDeposit = (address: string) => {
  depositWalletAddressVar(address)
  isWalletDepositOpenVar(true)
}
